import { render, staticRenderFns } from "./CollectionShareArea.vue?vue&type=template&id=6b900860&scoped=true"
import script from "./CollectionShareArea.vue?vue&type=script&lang=js"
export * from "./CollectionShareArea.vue?vue&type=script&lang=js"
import style0 from "./CollectionShareArea.vue?vue&type=style&index=0&id=6b900860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b900860",
  null
  
)

export default component.exports